export const orgCalendar = 'myqOrgCalendar';

export const birthdayCalendar = 'birthdays';
export const anniversaryCalendar = 'anniversaries';

/** Canonical 'YYYY-MM-DD' date key format used across the calendar views. */
export const DATE_KEY_FORMAT = 'YYYY-MM-DD';

/** Month + year header format, e.g. 'June 2026'. */
export const CALENDAR_HEADER_MONTH_FORMAT = 'MMMM YYYY';
